<!--分享红包提示-->
<template>
  <Layer :visible="visible" maskDirection="Middle">
    <div class="dlrLayer-middle">
      <div class="utilMod-dlrPopup">
        <span class="utilMod-dlrPopup-close" @click="close">关闭</span>
        <div class="utilMod-dlrPopup-title">分享成功</div>
        <div class="utilMod-dlrPopup-content">
          <div class="utilMod-dlrPopup-text">增加1次抢红包优惠券的机会</div>
          <div class="utilMod-dlrPopup-coupon">
            <p class="title">
              <span>{{ redPacketTypeText }}</span>
            </p>
            <p class="money">
              <sub>￥</sub>
              <em>{{ redPacket.value }}</em>
            </p>
            <p class="time">有效期至{{ redPacketEndTime }}</p>
          </div>
        </div>
        <div class="utilMod-dlrPopup-buttons">
          <span
            class="utilMod-dlrPopup-button utilMod-dlrPopup-button-bold"
            @click="close"
            >取消</span
          >
          <span
            class="utilMod-dlrPopup-button"
            @click="goRedpacket(redPacketUrl)"
            >开始抢</span
          >
        </div>
      </div>
    </div>
    <div class="dlrLayer-mask"></div>
  </Layer>
</template>
<script>
import utils from '../utils/util';
import { URLService } from '../services/url.service';
import Layer from './Layer';
const redPacketsType = {
  1: { sortId: 1, text: '购车优惠券' },
  2: { sortId: 4, text: '维修优惠券' },
  3: { sortId: 2, text: '装饰优惠券' },
  4: { sortId: 3, text: '保险优惠券' }
};
export default {
  components: {
    Layer
  },
  props: {
    redPacketList: {
      type: Array,
      dafault: function () {
        return [];
      }
    },
    closeLayer: {
      type: Function,
      default: function () {
        return false;
      }
    },
    salesId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      visible: true
    };
  },
  computed: {
    redPacketTypeText () {
      let result = redPacketsType[this.redPacket.redPacketsTypeId];
      let text = '';
      if (result) {
        text = result.text;
      }
      return text;
    },
    redPacketEndTime () {
      if (this.redPacket.endTime) {
        let dateStr = this.redPacket.endTime.substring(0, 19).replace('T', ' ').replace(/-/g, '/');
        return utils.formatTime(new Date(dateStr), 'yyyy.MM.dd');
      }
      return '';
    },
    redPacketUrl () {
      let landUrl = new URLService(this.redPacket.landUrl);
      landUrl.queryParams.remove('dealerId')
        .remove('cityid')
        .remove('siteId')
        .remove('busi')
        .remove('salesId')
        .append('salesId', this.salesId)
        .append('siteId', '315')
        .append('pvareaid', 6844448)
        .append('busi', 'dealerVr');
      return landUrl.build();
    },
    redPacket () {
      return this.filterAnthorRedpacket(this.redPacketList, this.redPacketId);
    }
  },
  methods: {
    close () {
      this.visible=false;
    },
    goRedpacket (url) {
      window.location.href = url;
    },
    filterAnthorRedpacket (redPacketList) {
      if (redPacketList.length === 1) {
        return redPacketList[0];
      }
      redPacketList.sort(function (a, b) {
        let aResult = redPacketsType[a.redPacketsTypeId] || { sortId: 0 };
        let bResult = redPacketsType[b.redPacketsTypeId] || { sortId: 0 };
        let result = aResult.sortId - bResult.sortId;
        if (result !== 0) {
          return result;
        }
        let aTime = 0;
        if (a.endTime) {
          let aDateStr = a.startTime.substring(0, 19).replace('T', ' ').replace(/-/g, '/');
          aTime = new Date(aDateStr).getTime();
        }
        let bTime = 0;
        if (b.endTime) {
          let bTimeStr = b.startTime.substring(0, 19).replace('T', ' ').replace(/-/g, '/');
          bTime = new Date(bTimeStr).getTime();
        }
        return aTime - bTime;
      });
      let activity = redPacketList[0];
      return activity;
    },
  }
};
</script>
<style lang="scss">
.utilMod-dlrPopup {
  position: relative;
  width: ptrd(560);
  background: #fff;
  border-radius: ptrd(24);
  padding: ptrd(40);
  box-sizing: border-box;

  &-close {
    display: block;
    position: absolute;
    top: ptrd(32);
    right: ptrd(32);
    width: ptrd(24);
    height: ptrd(24);
    font-size: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAABQUlEQVRIDbWVbXICIQyGxXqZ+ltHewTbWzgey/EWrUfQjv62p2mRBwmDXWCDH5lZwU3yPtnALoPBk82gb60138efBfPZ5HVrjLHMWy2nM0QE8V/798m1O57WBN4iTq7oSMEekIo58WUrhIJCzjLVYu4BoS0bcbZAcuKuxRs00YutKAW+Tcar0ppociIAmiaBOEwbewXQJmrF0esA+iD4/y8oPS+1MguoQYIv7paaOLFFQAnCfbE+ceKqAAJy/faJlbbgF+u8aOJ41Fh9glL1Ar+rRTlxBBF3PvUij6SadCyJsxWJc9s0QoCF/9k3vtOimrh7Av8Z18RIwVeAlkRtbARoE6QyRk2OB2gCU+F03pfrAfvD6Z2TSBI1209iGXOQFzP8mE/HX50XrVUcAIsfPnbx0OI+FlskZ+ijD/0L5om/Zz7lnedf57WWAAAAAElFTkSuQmCC);
    background-size: 100% 100%;
  }

  &-title {
    font-size: ptrd(34);
    color: #111e36;
    text-align: center;
    line-height: ptrd(34);
    padding-top: ptrd(24);
    font-weight: bold;
  }

  &-content {
  }

  &-text {
    font-size: ptrd(30);
    color: #666d7f;
    text-align: center;
    line-height: ptrd(42);
    margin-top: ptrd(34);
  }

  &-buttons {
    display: flex;
    padding-top: ptrd(42);
  }

  &-button {
    position: relative;
    flex: 1;
    display: block;
    line-height: ptrd(80);
    margin-left: ptrd(20);
    background: #0055ff;
    border-radius: ptrd(8);
    text-align: center;
    color: #fff;
    cursor: pointer;
    font-size: ptrd(32px);
    &:first-child {
      margin-left: 0;
    }

    &-bold {
      background: #fff;
      color: #0055ff;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border: 1px solid rgba(60, 120, 255, 0.2);
        border-radius: ptrd(8);
        pointer-events: none;
      }
    }

    &-disabled {
      background: #f1f3f6;
      color: #c5cad4;
    }
  }
  &-coupon {
    height: ptrd(204);
    width: ptrd(448);
    margin: ptrd(43) auto 0;
    background: url(https://s.autoimg.cn/dealer/m/dealerUI/dlrShare/card2x.png);
    background-size: 100% 100%;
    text-align: center;
    box-sizing: border-box;

    .title {
      padding-top: ptrd(16);

      span {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        font-size: ptrd(22);
        color: #ffffff;
        line-height: ptrd(24);
        font-weight: bold;

        &::after,
        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 50%;
          width: ptrd(22);
          height: ptrd(4);
          margin-top: ptrd(-2);
          background: rgba(255, 255, 255, 0.5);
        }

        &::after {
          left: ptrd(-38);
        }

        &::before {
          right: ptrd(-38);
        }
      }
    }

    .money {
      padding: ptrd(4) 0 ptrd(8px);
      height: ptrd(80px);
      display: flex;
      align-items: flex-end;
      justify-content: center;
      sub {
        display: block;
        font-size: ptrd(28);
        color: #ffffff;
        line-height: ptrd(60px);
      }

      em {
        display: block;
        @extend %font-number;
        font-size: ptrd(68);
        color: #ffffff;
        letter-spacing: 0;
      }
    }

    .time {
      font-size: ptrd(18);
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
    }
  }
}
</style>